import Core from './Core';
import Manipulators from './Manipulators';
import Representations from './Representations';
import Widgets3D from './Widgets3D';

export default {
  Core,
  Manipulators,
  Representations,
  Widgets3D,
};
